import {
  CamAddEditBilledForPeriod,
  CamAddEditBillingConfig,
  CamAddEditBillingLog,
  CamAddEditCashApp,
  CamAddEditInvoice,
  CamAddEditJournalEntry,
  CamAddEditLineItem,
  CamAddEditPayment,
  CamAddEditPendingPosting,
  CamAR360Report,
  CamBilledForPeriodListing,
  CamBillingConfig,
  CamBillingHistory,
  CamBillingLogs,
  CamCashAppList,
  CamDashboard,
  CamInvoiceListing,
  CamJournalEntryList,
  CamLineItems,
  CamPayment360InvoiceListing,
  CamPayment360Report,
  CamPaymentListing,
  CamPendingPostingListing,
  CamReports,
  CamToleranceReport,
} from "@/pages";
import { routes } from "../utils";

export const DashboardRoutes = () => {
  return {
    path: routes.dashboard,
    children: [
      {
        path: "",
        element: <CamDashboard />,
      },
      {
        path: routes.invoice + "/" + routes.add,
        element: <CamAddEditInvoice />,
      },
      {
        path: routes.invoice + "/" + routes.invoiceAction,
        element: <CamInvoiceListing />,
      },
      {
        path:
          routes.invoice +
          "/" +
          routes.invoiceAction +
          "/" +
          routes.invoiceId +
          "/" +
          routes.action,
        element: <CamAddEditInvoice />,
      },
      {
        path: routes.payment + "/" + routes.add,
        element: <CamAddEditPayment />,
      },
      {
        path: routes.payment + "/" + routes.paymentAction,
        element: <CamPaymentListing />,
      },
      {
        path:
          routes.payment +
          "/" +
          routes.paymentAction +
          "/" +
          routes.paymentId +
          "/" +
          routes.action,
        element: <CamAddEditPayment />,
      },
      {
        path: routes.payment + "/" + routes.reports,
        children: [
          {
            path: "",
            element: <CamPayment360Report />,
          },
          {
            path: routes.glId + "/" + routes.month,
            children: [
              {
                path: "",
                element: <CamPayment360InvoiceListing />,
              },
              {
                path: routes.invoiceId + "/" + routes.action,
                element: <CamAddEditInvoice />,
              },
            ],
          },
          {
            path:
              routes.glId +
              "/" +
              routes.month +
              "/" +
              routes.listing +
              "/" +
              routes.paymentAction,
            children: [
              {
                path: "",
                element: <CamPaymentListing />,
              },
              {
                path: routes.paymentId + "/" + routes.action,
                element: <CamAddEditPayment />,
              },
            ],
          },
        ],
      },
      {
        path: routes.payment + "/" + routes.tolerance,
        children: [
          {
            path: "",
            element: <CamToleranceReport />,
          },
          {
            path:
              routes.budgetMgmt +
              "/" +
              routes.budgetId +
              "/" +
              routes.lineItems,
            children: [
              {
                path: "",
                element: <CamLineItems />,
              },
              {
                path: routes.lineItemId + "/" + routes.action,
                element: <CamAddEditLineItem />,
              },
            ],
          },
        ],
      },
      {
        path: routes.billingConfig,
        element: <CamBillingConfig />,
      },
      {
        path: routes.billingConfig + "/" + routes.add,
        element: <CamAddEditBillingConfig />,
      },
      {
        path:
          routes.billingConfig + "/" + routes.billingId + "/" + routes.action,
        element: <CamAddEditBillingConfig />,
      },
      {
        path: routes.pendingPosting,
        element: <CamPendingPostingListing />,
      },
      {
        path:
          routes.pendingPosting + "/" + routes.billingId + "/" + routes.action,
        element: <CamAddEditPendingPosting />,
      },
      {
        path: routes.billedForPeriod,
        element: <CamBilledForPeriodListing />,
      },
      {
        path:
          routes.billedForPeriod + "/" + routes.billingId + "/" + routes.action,
        element: <CamAddEditBilledForPeriod />,
      },
      {
        path: routes.billingLog,
        element: <CamBillingLogs />,
      },
      {
        path: routes.billingLog + "/" + routes.billingId + "/" + routes.action,
        element: <CamAddEditBillingLog />,
      },
      {
        path: routes.journalEntry,
        element: <CamJournalEntryList />,
      },
      {
        path: routes.journalEntry + "/" + routes.action,
        element: <CamAddEditJournalEntry />,
      },
      {
        path:
          routes.journalEntry + "/" + routes.billingId + "/" + routes.action,
        element: <CamAddEditJournalEntry />,
      },
      {
        path: routes.reports,
        element: <CamReports />,
      },
      {
        path: routes.cashApp,
        children: [
          {
            path: "",
            element: <CamCashAppList />,
          },
          {
            path: routes.add,
            element: <CamAddEditCashApp />,
          },
          {
            path: routes.id + "/" + routes.status + "/" + routes.action,
            element: <CamAddEditCashApp />,
          },
        ],
      },
      {
        path: routes.billingHistory,
        element: <CamBillingHistory />,
      },
      {
        path: routes.ar360,
        element: <CamAR360Report />,
      },
    ],
  };
};
